import facade from './facade.png'

const content = `<p>The Facade design pattern looks like the <a href="/adapter">Adapter</a> design pattern as it introduces a component in between others that have different interfaces, but with the following differences:</p>

<ul><li>the purpose of the Facade is to orchestrate several components and provide a simplified interface for common usages of those components</li><li>clients of the Facade are allowed to access directly the components if they have a usage that is not covered by the Facade</li></ul>

<img src=${facade} alt=facade />`

export default content
